import { Component } from "react";
import { connect } from "react-redux";
import { matchSorter } from "match-sorter";
import AbsenceTable from "./AbsenceTable";
import AbsenceStatusIcon from "./AbsenceStatusIcon";
import {
    setEditionState,
    selectAbsence,
    getDaysNumber,
} from "../../redux/absences/absencesActions";
import { getRefuseReasons } from "../../redux/absences/absencesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import moment from "moment";
import "./AbsenceTable.css";

class AbsencesToValidateTable extends Component {
    constructor(props) {
        super(props);

        props.getRefuseReasons();

        this.state = {
            columns: [
                {
                    Header: "Absences à valider",
                    columns: [
                        {
                            Header: "Statut",
                            id: "state",
                            filterable: false,
                            width: 100,
                            Cell: ({ value }) => {
                                if (!value) return null;

                                return (
                                    <div className="margin-status-icon">
                                        <AbsenceStatusIcon status={value} />
                                    </div>
                                );
                            },
                        },
                        {
                            Header: "Employé",
                            accessor: "emp_name",
                            filterMethod: (filter, row) =>
                                row[filter.id].startsWith(filter.value) &&
                                row[filter.id].endsWith(filter.value),
                        },
                        {
                            Header: "Début",
                            id: "date_from",
                            accessor: (a) =>
                                moment(a.date_ids[0].date).format("DD/MM/YYYY"),
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, {
                                    keys: ["date_from"],
                                }),
                            filterAll: true,
                        },
                        {
                            Header: "Fin",
                            id: "date_to",
                            accessor: (a) =>
                                moment(
                                    a.date_ids[a.date_ids.length - 1].date
                                ).format("DD/MM/YYYY"),
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, {
                                    keys: ["date_to"],
                                }),
                            filterAll: true,
                        },
                        {
                            Header: "Nb Jours",
                            id: "nbDays",
                            accessor: (a) => getDaysNumber(a.date_ids),
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, {
                                    keys: ["nbDays"],
                                }),
                            filterAll: true,
                        },
                        {
                            Header: "Agence",
                            accessor: "company_code",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, {
                                    keys: ["status"],
                                }),
                            filterAll: true,
                        },
                        {
                            Header: "Département",
                            accessor: "department_name",
                            filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, {
                                    keys: ["status"],
                                }),
                            filterAll: true,
                        },
                        {
                            Header: "Code",
                            accessor: "code",
                            filterMethod: (filter, row) =>
                                row[filter.id].startsWith(filter.value) &&
                                row[filter.id].endsWith(filter.value),
                        },
                    ],
                },
            ],
        };
    }

    getTableTrProps(row) {
        if (row) {
            return {
                onClick: () => {
                    this.props.setEditionState(false, false, true);
                    this.props.selectAbsence(row.row.original);
                    this.props.history.push("/absences/validateAbsence");
                },
                style: {
                    cursor: "pointer",
                },
            };
        } else {
            return {};
        }
    }

    render() {
        return (
            <div>
                <AbsenceTable
                    data={this.props.absences.absences}
                    columns={this.state.columns}
                    filterable={false}
                    getTrProps={this.getTableTrProps.bind(this)}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setEditionState: (creationMode, updateMode, validationMode) =>
            dispatch(setEditionState(creationMode, updateMode, validationMode)),
        selectAbsence: (absence) => dispatch(selectAbsence(absence)),
        getRefuseReasons: () => dispatch(getRefuseReasons()),
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(AbsencesToValidateTable);
